/*!
 * feng-performance  Library v1.0.7
 * https://m.fengjr.com/
 *
 *
 * Copyright qiaobin
 * Released under the MIT license
 *
 * Date: 2018-10-31T07:47Z
 */
( function( global, factory ) {

    "use strict";

    if ( typeof module === "object" && typeof module.exports === "object" ) {

        // For CommonJS and CommonJS-like environments where a proper `window`
        // is present, execute the factory and get feng-performance.
        // For environments that do not have a `window` with a `document`
        // (such as Node.js), expose a factory as module.exports.
        // This accentuates the need for the creation of a real `window`.
        // e.g. var feng-performance = require("feng-performance")(window);
        // See ticket #14549 for more info.
        module.exports = global.document ?
            factory( global, true ) :
            function( w ) {
                if ( !w.document ) {
                    throw new Error( "feng-performance requires a window with a document" );
                }
                return factory( w );
            };
    } else {
        factory( global );
    }

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of feng-performance 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
    "use strict";




	var Performance = function() {
		this._uid = "";
		this._time = 0;
		this.reactLoadTime = 0;
		this.reactParseTime = 0;
		this.firstScreenTime = 0;
		this.defaultTiming = {
			dnsTime: 0,
			tcpTime: 0,
			firstPaintTime: 0,
			domRenderTime: 0,
			loadTime: 0,
			reactParseTime: 0,
			reactLoadTime: 0,
			htmlParseTime: 0
		};
		this.start = function() {
			this._time = this.now();
		};

		this.end = function() {
			return Math.round( this.now() - this._time );
		};

		this.getEnd = function() {
			var start = performance.now();
			return function() {
				return Math.round( performance.now() - start );
			};
		};

		this.now = function() {
			if ( !window.performance || !window.performance.now ) {
				return 0;
			}
			return window.performance.now();
		};

		this.reactLoadReady = function() {
			this.reactLoadTime = this.now();
		};

		this.reactParseReady = function() {
			this.reactParseTime = this.now();
		};

		this.firstScreenTime = function() {
			this.firstScreenTime = this.now();
		};

		this.calculateWebLoadTiming = function() {
			if ( !window.performance || !window.performance.timing ) {
				return this.defaultTiming;
			}
			var timing = window.performance.timing;
			var start = timing.navigationStart;
			var result = {
				dnsTime: timing.domainLookupEnd - timing.domainLookupStart,
				tcpTime: timing.connectEnd - timing.connectStart,
				firstPaintTime: timing.responseStart - start,
				firstScreenTime: Math.round( this.firstScreenTime ),
				domRenderTime: timing.domContentLoadedEventEnd - start,
				loadTime: timing.loadEventEnd - start,
				reactParseTime: Math.round( this.reactParseTime ),
				reactLoadTime: Math.round( this.reactLoadTime ),
				htmlParseTime: timing.domLoading - start
			};
			return result;
		};

		this.setUid = function( uid ) {
			this._uid = uid;
		};

		this.getUid = function() {
			return this._uid;
		};

	};

	var performance = new Performance();



	var envType = {
		Beta: 1,
		Production: 2
	};



	var traceType = {
		H5: "h5",
		Web: "web"
	};



	var Math = window.Math;
    var Image = window.Image;
	var base = "https://analysis.fengjr.com/analysis";
	var _traceType = traceType.H5;
	var perfClient = function() {
	};

	function sendTime( param ) {
		var img = new Image( 1, 1 );
		img.src = base + "/b.gif?" + param;
	};

	function joinParam( paramObj ) {
		var param = [];
		for ( var filed in paramObj ) {
			param.push( filed + "=" + encodeURIComponent( paramObj[ filed ] ) );
		}
		return param.join( "&" );
	};

	function getTraceID() {
		var time = new Date().getTime().toString();
		var randomNumber1 = Math.random().toString( 36 ).substr( 2 );
		var randomNumber2 = Math.random().toString( 36 ).substr( 2, 13 - randomNumber1.length );
		return time + "^" + randomNumber1 + randomNumber2;
	};

	perfClient.prototype.setEnv = function( type ) {
		if ( type === envType.Beta ) {
			base = "http://10.255.72.58/analysis";
		} else if ( type === envType.Production ) {
			base = "https://analysis.fengjr.com/analysis";
		}
	};

	perfClient.prototype.setTraceType = function( type ) {
		_traceType = type;
	};

	perfClient.prototype.getTraceID = function() {
		return getTraceID();
	};

	perfClient.prototype.sendWebLoadTime = function() {
		var time = performance.calculateWebLoadTiming();
		var param = {
			page_url: window.location.href,
			first_paint_time: time.firstPaintTime,
			first_screen_time: time.firstScreenTime || time.reactLoadTime || time.loadTime,
			dom_ready_time: time.domRenderTime,
			onload_time: time.loadTime,
			version: 4,
			trace_type: _traceType,
			request_type: "page",
			uid: performance.getUid()
		};
		sendTime( joinParam( param ) );
	};

	perfClient.prototype.sendAjaxTime = function( option, totalTime, responseCode ) {
		var param = {
			ajax_url: option.ajaxUrl,
			page_url: window.location.href,
			method: option.method,
			content_type: option.contentType,
			param: option.param,
			uid: performance.getUid(),
			total_time: totalTime,
			response_code: responseCode,
			version: 4,
			trace_type: _traceType,
			request_type: "ajax",
			trace_id: option.traceId || getTraceID(),
			span_id: "0",
			business_success: option.businessSuccess === undefined ? true : option.businessSuccess,
			fail_reason: option.failReason,
			content_size: option.contentSize
		};
		sendTime( joinParam( param ) );
	};
/**
 * Created by qiaobin on 18/9/21.
 */

    var fengPerformance = {
		Performance: performance,
		EnvType: envType,
		TraceType: traceType,
		PerfClient: new perfClient()
	};


// Register as a named AMD module, since fengPerformance can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase fengPerformance is used because AMD module names are
// derived from file names, and fengPerformance is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of fengPerformance, it will work.

// Note that for maximum portability, libraries that are not fengPerformance should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. fengPerformance is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( typeof define === "function" && define.amd ) {
	define( "fengPerformance", [], function() {
		return fengPerformance;
	} );
}




var

	// Map over fengPerformance in case of overwrite
	_fengPerformance = window.fengPerformance;

fengPerformance.noConflict = function( deep ) {

	if ( deep && window.fengPerformance === fengPerformance ) {
		window.fengPerformance = _fengPerformance;
	}

	return fengPerformance;
};

// Expose fengPerformance and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/fengPerformance/fengPerformance/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.fengPerformance =  fengPerformance;
}




    return fengPerformance;
} );



//////////////////
// WEBPACK FOOTER
// ./node_modules/feng-performance/dist/fengPerf.js
// module id = 77
// module chunks = 12